export default __webpack_public_path__ + "static/media/Nootnootpinguin.2f1ed25d.png";